var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_789_11666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2367 1.70527H11.4502V1.3434C11.4502 0.96901 11.1407 0.666992 10.7602 0.666992H5.2391C4.85862 0.666992 4.54913 0.96901 4.54913 1.3434V1.70527H3.76263C2.97329 1.70527 2.33301 2.32044 2.33301 3.07479V13.9641C2.33301 14.7185 2.97329 15.3337 3.76263 15.3337H12.2381C13.0261 15.3337 13.6663 14.7185 13.6663 13.9641V3.07479C13.6663 2.32044 13.0261 1.70527 12.2381 1.70527H12.2367ZM5.92765 2.01981H10.0689V2.74354H5.92907V2.01981H5.92765ZM12.2367 13.9808L3.71294 13.9641L3.76121 3.05808H4.54771V3.41995C4.54771 3.79434 4.8572 4.09636 5.23768 4.09636H10.7602C11.1407 4.09636 11.4502 3.79434 11.4502 3.41995V3.06504L12.285 3.07339L12.2367 13.9794V13.9808Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.92536 7.37109H6.07376C5.69328 7.37109 5.38379 7.67311 5.38379 8.0475C5.38379 8.42189 5.69328 8.72391 6.07376 8.72391H9.92536C10.3058 8.72391 10.6153 8.42189 10.6153 8.0475C10.6153 7.67311 10.3058 7.37109 9.92536 7.37109Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.92536 9.82617H6.07376C5.69328 9.82617 5.38379 10.1282 5.38379 10.5026C5.38379 10.877 5.69328 11.179 6.07376 11.179H9.92536C10.3058 11.179 10.6153 10.877 10.6153 10.5026C10.6153 10.1282 10.3058 9.82617 9.92536 9.82617Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_789_11666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.3333,
    height: 14.6667,
    fill: "white",
    transform: "translate(2.33301 0.666992)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocIcon);
export default __webpack_public_path__ + "static/media/doc-icon.5db0748b.svg";
export { ForwardRef as ReactComponent };